/**
 * Tiered sticky header group
 * Makes each .shopify-section-group-header-group section sticky in stacked order:
 * image-announcement-bar → announcement-bar → header nav
 * Each section sticks at the cumulative height of all sticky sections above it.
 */
(function () {
  if (window.__stickyHeaderGroupInit) return;
  window.__stickyHeaderGroupInit = true;

  function applyTieredSticky() {
    const sections = document.querySelectorAll('.shopify-section-group-header-group');
    let cumulativeTop = 0;

    sections.forEach(function (section, index) {
      // position:sticky is set in CSS; only top and z-index need JS (heights are dynamic)
      section.style.top = cumulativeTop + 'px';
      section.style.zIndex = 300 - index;
      cumulativeTop += section.offsetHeight;
    });
  }

  function init() {
    applyTieredSticky();
    // Recalculate on resize (heights may change on mobile)
    window.addEventListener('resize', applyTieredSticky);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
